import { render, staticRenderFns } from "./eventShow.vue?vue&type=template&id=eeff4b70&"
import script from "./eventShow.vue?vue&type=script&lang=js&"
export * from "./eventShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports